module.exports = __webpack_public_path__ + "img/silver3.f84bc372.png";